module.exports = __webpack_public_path__ + "static/media/th_bg_pad_portrait.a16bd076.png";